import { SuperHeroCard } from 'ui/components';

export const SuperHeroCardFeature: React.FC<Umbraco.SuperHeroCard> = ({ content, settings }) => {
	return <SuperHeroCard {...content?.properties} {...settings?.properties} />;
};
